<app-modal-filler-atom
  (click)="close()"
  [index]="(index$ | async) ?? 0"
></app-modal-filler-atom>
<div
  class="fixed left-0 right-0 overflow-y-auto shadow md:left-0 md:top-0 md:flex md:h-full md:w-full md:items-center md:justify-center mdMax:mx-auto mdMax:max-h-85-screen mdMax:max-w-screen-sm"
  [style.z-index]="((index$ | async) ?? 0) + 50"
  [style.bottom.px]="keyboardOffset"
  [class.mdMax:bottom-0]="keyboardOffset === 0"
>
  @if (isDesktop$ | async) {
    <app-modal-filler-atom
      [withBackdrop]="false"
      (click)="close()"
      [index]="(index$ | async) ?? 0"
    ></app-modal-filler-atom>
  }
  <div
    class="rounded-t-3xl p-5 md:w-2/5 md:min-w-448 md:max-w-lg md:rounded-3xl md:p-7" [style.backgroundColor]="backgroundColor | contentBuilderColor: '#FFFFFF'"
    [style.z-index]="((index$ | async) ?? 0) + 50"
  >
    <h1
      class="pb-5 font-brand text-28px font-bold text-neutral-800"
      translate="zerosix.link-account.header"
    ></h1>
    @if (step === 'link-form' || step === 'verification-code') {
      <div class="relative pb-6">
        @if (step === 'link-form') {
          <app-kiosk-input-country-phone-atom
            [phone]="phoneForm.value ?? ''"
            [useLocalFormat]="false"
            [defaultRegionCode]="defaultRegionCode()"
            (updatePhone)="phoneForm.setValue($any($event))"
            (keyup.enter)="onSubmit()"
          />
          @if (phoneForm.invalid && (phoneForm.dirty || phoneForm.touched)) {
            @if (phoneForm.errors) {
              <span
                class="absolute bottom-1 block font-base text-xs font-normal text-error-700"
                translate="signup.invalid-phone"
              ></span>
            }
          }
          @if (phoneErrorMessage) {
            <span
              class="font-base text-xs font-normal text-error-700"
              [translate]="phoneErrorMessage"
            ></span>
          }
        }
        @if (step === 'verification-code') {
          <label
            for="authCode"
            class="mb-1 block font-base text-sm font-normal leading-5 text-neutral-600"
            translate="zerosix.link-account.enter-auth-code"
          ></label>
          <input
            id="authCode"
            type="text"
            [formControl]="authForm"
            (keyup.enter)="onSubmit()"
            class="flex w-full border border-solid border-neutral-300 bg-neutral-50 px-5 py-8xs font-base text-base font-normal leading-5"
            [class.border-error-700]="
              authCodeErrorMessage || (authForm.errors && (authForm.dirty || authForm.touched))
            "
          />
          @if (authForm.invalid && (authForm.dirty || authForm.touched)) {
            @if (authForm.errors) {
              <span
                class="absolute bottom-1 block font-base text-xs font-normal text-error-700"
                translate="zerosix.link-account.errors.invalid-auth-code"
              ></span>
            }
          }
          @if (authCodeErrorMessage) {
            <span
              class="font-base text-xs font-normal text-error-700"
              [translate]="authCodeErrorMessage"
            ></span>
          }
        }
        @if (errorMessage) {
          <div class="self-center">
            <span
              class="font-base text-xs font-normal text-error-700"
              [translate]="errorMessage"
            ></span>
          </div>
        }
      </div>
      <div class="flex flex-col">
        @if (phoneErrorMessage === 'zerosix.link-account.errors.account-not-found') {
          <div class="pb-4">
            <app-button-atom
              size="M"
              [label]="'zerosix.link-account.create-new-account' | translate"
              (click)="openCreateLoyaltyAccountModal()"
              type="light"
              [full]="true"
            ></app-button-atom>
          </div>
        }
        <div class="flex gap-2 pt-1 xm:flex-nowrap">
          <div class="w-full xm:w-1/2">
            <app-button-atom
              size="M"
              [label]="'zerosix.cancel' | translate"
              (click)="close()"
              type="light"
              [full]="true"
            ></app-button-atom>
          </div>
          <div class="w-full xm:w-1/2">
            <app-button-atom
              [iconUrl]="isValidating ? 'assets/images/spinner.svg' : ''"
              [disabled]="isStepSubmitButtonDisabled"
              size="M"
              [label]="'zerosix.validate' | translate"
              type="primary"
              [full]="true"
              (click)="onSubmit()"
            ></app-button-atom>
          </div>
        </div>
      </div>
    }

    @if (step === 'confirmation') {
      <div class="flex flex-col gap-10">
        <p class="mb-0.5 flex items-center font-base text-base text-neutral-800">
          <span><i class="icon icon-n-check mr-1.5 mt-1 text-xl text-success-600"></i></span>
          {{ 'zerosix.link-account.success-message' | translate }}
        </p>
        <app-button-atom
          size="L"
          [label]="'zerosix.validate' | translate"
          type="primary"
          [full]="true"
          (click)="close()"
        ></app-button-atom>
      </div>
    }
  </div>
</div>
